import { useCampaignClassificationCatalog, useCreateCampaign, useUpdateCampaign } from '@/hooks/useCampaigns'

// The shared New/Edit form container's data-composition layer — the sole
// consumer of the Classification-catalog and create/update hooks for the form
// route wrappers. `CampaignForm` (presentational) never calls a hook itself;
// `pages/Campaigns/new/index.tsx` and `pages/Campaigns/edit/index.tsx` both
// consume this container and pass its option lists and mutation state down.

export function useCampaignFormContainer() {
	const catalog = useCampaignClassificationCatalog()
	const createMutation = useCreateCampaign()
	const updateMutation = useUpdateCampaign()

	return {
		isCatalogLoading: catalog.isLoading,
		objective: catalog.data?.objective,
		geography: catalog.data?.geography,
		brand: catalog.data?.brand,
		product: catalog.data?.product,
		createMutation,
		updateMutation,
	}
}
